module.exports = __webpack_public_path__ + "static/img/banner_letterservice-2.1f9d772.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/user/banner_letterservice-2.jpg
// module id = V5ah
// module chunks = 0